export class HttpErrorResponse {
    public errorCode: number;
    public errorMessage: string;

    constructor(errorcode: number, errormessage: string) {
        this.errorCode = errorcode;
        this.errorMessage = '';
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/model/httperror-response.ts